var _defs, _circle, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        stroke: #000;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.5,
    cy: 37.5,
    r: 29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.46,40.01l6.65,6.65c1.17,1.17,3.07,1.17,4.24,0l19.19-19.19"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tic"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 12.19,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.78,
    y: 0,
    xmlSpace: "preserve"
  }, " - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 25.11,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.09,
    y: 0
  }, "n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOn);
export default __webpack_public_path__ + "static/media/__Tick On.aba6a9134b0797038e3df4b6aac57e03.svg";
export { ForwardRef as ReactComponent };